<template>
  <div class="matchmaker-detail-page">
    <div class="detail-hero">
      <div class="hero-image" aria-hidden="true"></div>
      <div class="hero-copy">
        <div class="hero-title">优秀红娘</div>
        <div class="hero-desc">专业牵线 · 温柔陪伴，帮你更快遇见合适的人</div>
      </div>
      <button class="hero-btn hero-btn-left" @click="onClickLeft">
        <van-icon name="arrow-left" />
      </button>
    </div>

    <div class="detail-main">
      <div class="detail-card detail-profile-card">
        <div class="avatar-box" @click="previewAvatar">
          <img :src="matchmakerInfo.avatarLink || defaultPhoto" alt="">
        </div>
        <div class="gender-badge">
          <img :src="matchmakerInfo.sex === 1 ? manPhoto : womanPhoto" alt="">
        </div>
        <div class="profile-name-row">
          <span class="profile-name">{{ matchmakerInfo.name || '红娘' }}</span>
          <span class="profile-tag">{{ routeTitleTag }}</span>
        </div>
        <div class="profile-subtitle">{{ profileSubtitle }}</div>

        <div class="stats-grid">
          <div class="stat-item">
            <div class="stat-number">{{ matchmakerInfo.points || 0 }}</div>
            <div class="stat-label">积分</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">{{ matchmakerInfo.followUpQuantity || 0 }}</div>
            <div class="stat-label">跟进数</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">{{ getMatchPartitionName(matchmakerInfo.workArea) || '--' }}</div>
            <div class="stat-label">工作区域</div>
          </div>
        </div>
      </div>

      <div class="detail-card info-card">
        <div class="section-title">基础信息</div>
        <div class="info-list">
          <div class="info-row"><span class="info-label">姓名</span><span class="info-value">{{ matchmakerInfo.name || '--' }}</span></div>
          <div class="info-row"><span class="info-label">部门</span><span class="info-value">{{ matchmakerInfo.department || '--' }}</span></div>
          <div class="info-row"><span class="info-label">工号</span><span class="info-value">{{ matchmakerInfo.employeeNo || '--' }}</span></div>
          <div class="info-row"><span class="info-label">工作区域</span><span class="info-value">{{ getMatchPartitionName(matchmakerInfo.workArea) || '--' }}</span></div>
          <div class="info-row"><span class="info-label">联系方式</span><span class="info-value">{{ matchmakerInfo.contactNumber || '--' }}</span></div>
          <div class="info-row" v-if="$route.name === 'excellentMatchmakerDetail'">
            <span class="info-label">微信号</span>
            <span class="info-value info-copy-wrap">
              <span>{{ matchmakerInfo.weChatNumber || '--' }}</span>
              <span
                v-if="matchmakerInfo.weChatNumber"
                class="copy-btn"
                v-clipboard:copy="matchmakerInfo.weChatNumber"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              >复制</span>
            </span>
          </div>
        </div>
      </div>

      <div class="detail-card info-card">
        <div class="section-title">个人介绍</div>
        <div class="desc-block">
          <div class="desc-title">个人特长</div>
          <div class="desc-text">{{ matchmakerInfo.personalStrength || '暂未填写' }}</div>
        </div>
        <div class="desc-block">
          <div class="desc-title">自我介绍</div>
          <div class="desc-text">{{ matchmakerInfo.selfIntroduction || '暂未填写' }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Icon, Toast, ImagePreview } from "vant";
import { getMatchmakerInfo } from "../api/matchmakerInfo";
import womanPhoto from "../assets/icon_female@2x.png";
import manPhoto from "../assets/icon_male@2x.png";
import defaultPhoto from "../assets/defaultPhoto.png";

export default {
  data() {
    return {
      matchmakerInfo: {},
      womanPhoto,
      manPhoto,
      defaultPhoto,
      matchPartition: [
        { text: "W区", value: 1 },
        { text: "E区", value: 2 },
        { text: "M区", value: 3 },
        { text: "R区", value: 4 },
        { text: "东莞", value: 15 }
      ]
    };
  },
  components: {
    [Icon.name]: Icon
  },
  computed: {
    routeTitleTag() {
      return this.$route.name === "excellentMatchmakerDetail" ? "联系红娘" : "红娘简介";
    },
    profileSubtitle() {
      const area = this.getMatchPartitionName(this.matchmakerInfo.workArea);
      const dept = this.matchmakerInfo.department || "未填写部门";
      return [dept, area].filter(Boolean).join(" · ");
    }
  },
  methods: {
    getMatchPartitionName(value) {
      var result = this.matchPartition.find(it => it.value == value);
      if (result != null) {
        return result.text;
      }
      return "";
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    onCopy() {
      Toast.success({ message: "复制成功" });
    },
    onError() {
      Toast.fail({ message: "当前环境不支持复制" });
    },
    previewAvatar() {
      if (this.matchmakerInfo.avatarLink) {
        ImagePreview({
          images: [this.matchmakerInfo.avatarLink],
          closeable: true,
          closeIconPosition: "top-right"
        });
      }
    }
  },
  created() {
    getMatchmakerInfo({ id: this.$route.params.id }).then(res => {
      if (res.code === 20000) {
        this.matchmakerInfo = res.data;
      }
    });
  }
};
</script>
<style lang="less" src="../style/excellentMatchmaker.less" />



// WEBPACK FOOTER //
// src/views/excellentMatchmaker.vue